import React, { useRef, useEffect } from 'react';
import './classic-half-sized-bus-status-component.css';
import axios from 'axios';
import liveTrainTrackerImage from '../../images/live_train_estimate_logo_white.png';

export default function ClassicHalfSizedBusStatusComponent({ busData, bannerId }) {
  const textRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const textEl = textRef.current;
    const wrapperEl = wrapperRef.current;
    if (!textEl || !wrapperEl) return;

    const overflow = textEl.scrollWidth > wrapperEl.clientWidth;
    const distance = overflow
      ? `-${textEl.scrollWidth - wrapperEl.clientWidth}px`
      : '0px';

    textEl.style.setProperty('--scroll-distance', distance);

    // Restart animation when stop name changes
    textEl.style.animation = 'none';
    void textEl.offsetWidth; // trigger reflow

    if (overflow) {
      textEl.style.animation = 'scroll-text 3s linear forwards';
    }
  }, [busData]);

  return (
    <div
      className="half-bus-status-information-container"
      id={'half-bus-status-information-container-' + bannerId}
    >
      <div className="hbs-station-and-line-container">
        <div className="hbs-station-container">
          {busData.routeNumber} {busData.routeDirection}
        </div>

        <div className="hbs-line-color-container">
          <img src={liveTrainTrackerImage} className="hbs-bus-image" alt="Bus" />

          {/* Scrolling stop name wrapper */}
          <div className="hbs-line-color-text-wrapper" ref={wrapperRef}>
            <div className="hbs-line-color-text" ref={textRef}>
              {busData.stopName}
            </div>
          </div>
        </div>
      </div>

      <div className="hbs-destination-and-estimates-container">
        <div className="hbs-destination-and-estimates-container-right">
          <div className="hbs-destination-and-estimates">
            <div className="hbs-estimates-container">
              <div className="hbs-estimate">
                {busData.predictionOne}{' '}
              </div>
              <div className='hbs-estimate-later-predictions'>
                {busData.predictionTwo}
              </div>
              <div className='hbs-estimate-later-predictions'>
                {busData.predictionThree}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
